/** Flat bonus when Bounty (`b`) pays out (correct 1×2). Stake is season Stack. */

const BOUNTY_AUGMENT_CODE = 'b';
const BOUNTY_STAKE_MIN = 5;
const BOUNTY_STAKE_MAX = 20;

/**
 * True when `n` is an allowed Bounty stake (integer 5–20).
 * @param {unknown} n
 */
function isValidBountyStake(n) {
  return Number.isInteger(n) && n >= BOUNTY_STAKE_MIN && n <= BOUNTY_STAKE_MAX;
}

/**
 * Stake to persist/score. Invalid values become 0 (no bonus).
 * @param {unknown} raw
 */
function resolveBountyPoints(raw) {
  const n = Number(raw);
  if (isValidBountyStake(n)) return n;
  return 0;
}

/**
 * Clamp a requested stake into 5…min(20, available). Returns 0 when available < 5.
 * @param {unknown} requested
 * @param {unknown} available
 */
function clampBountyStake(requested, available) {
  const cap = Math.min(BOUNTY_STAKE_MAX, Number(available) || 0);
  if (!Number.isFinite(cap) || cap < BOUNTY_STAKE_MIN) return 0;
  const n = Number(requested);
  const start = Number.isInteger(n) ? n : BOUNTY_STAKE_MIN;
  return Math.max(BOUNTY_STAKE_MIN, Math.min(cap, start));
}

module.exports = {
  BOUNTY_AUGMENT_CODE,
  BOUNTY_STAKE_MIN,
  BOUNTY_STAKE_MAX,
  isValidBountyStake,
  resolveBountyPoints,
  clampBountyStake
};
